import { Component, ElementRef, Input, QueryList, TemplateRef, ViewChildren } from '@angular/core';
import { VexPopoverCloseEvent, VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { ToolbarItem, ToolbarPopover } from '@vex/interfaces/toolbar-item.interface';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { ResizedEvent } from 'angular-resize-event';
import { Observable, of,map, startWith, switchMap } from 'rxjs';

@Component({
  selector: 'vex-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent {

  @ViewChildren('toolbarItem') toolbarItems: QueryList<ElementRef<HTMLDivElement>>;

  @Input() mobileQuery: boolean;
  @Input() public offsetWidth: any; 

  @Input()
  showRecordItems: boolean = false;
  @Input() items: ToolbarItem[] = [];
  
	@Input() offset: number = 0
  
  currentMaxWidth: number;
  hasHiddenItems: boolean;
  popoverOpen$: Observable<boolean> = of(false);

  private menuRef: VexPopoverRef<unknown>;

  constructor(private layoutService: VexLayoutService,
              public host: ElementRef,
              private popoverService: VexPopoverService) {}

  openSidenav(): void {
    this.layoutService.openSidenav();
  }

  openSearch(): void {
    this.layoutService.openSearch();
  }

  name(menu: any): string {
      if (typeof menu.name === "function") {
        return menu.name();
      }
      return menu.name;
	}

  icon(menu: any): string{
    if(typeof menu.icon  === "function"){
      return menu.icon();
    }
    return menu.icon;
  }

  propertyOf<T>(property : T) {
    if (typeof property === "function") {
			return property();
		}
		return property;
  }

  onResize(event: ResizedEvent) { 
    this.hasHiddenItems = false;
    let containerBoxSize = event.newRect;
    if (containerBoxSize.right > 0){
      let totalWidthItems = 0;
      if (this.items.length > 1) { 
        this.items.forEach(item => {
          if(item.size){
            totalWidthItems = totalWidthItems + item.size.right + 20;
            item.hide = containerBoxSize.right - (this.hasHiddenItems ? 30 : 0) < totalWidthItems;
            if(item.hide) {
              this.hasHiddenItems = true;
            }
          }
        });
      }
    }
  }
  
  // openMfaMenu(origin: HTMLDivElement,popoverRef: PopoverRef) {
  //  popoverRef = this.openPopover(origin, this.mfaMenu);

  //   this.databaseMenuOpen$ = of(
  //    popoverRef
  //   ).pipe(
  //     switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
  //     startWith(true),
  //   );
  // }

  // private openPopover(origin: HTMLDivElement, template: TemplateRef<any>): PopoverRef<any> {
  //   return this.popoverService.open({
  //     content: template,
  //     origin,
  //     //offsetY: -8,
  //     width: origin.clientWidth,
  //     position: [
  //       {
  //         originX: 'end',
  //         originY: 'center',
  //         overlayX: 'end',
  //         overlayY: 'center'
  //       }
  //     ]
  //   });
  // }


  openPopover(origin: HTMLDivElement | ElementRef<any>, item: ToolbarPopover): void {
    item.opened = true;
    const screenWidth = window.innerWidth;
    const maxWidth = screenWidth > 768 ? '58vw' : '90vw';

    this.menuRef = this.popoverService.open({
      content: item.popover(),
      origin,
      offsetY: 0,
      width: 'auto',
      maxWidth: maxWidth,
      maxHeight: '65vh',
      position: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top'
        }
      ],
    });

    item.action(item);
    this.popoverOpen$ = of(this.menuRef).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );

    this.menuRef.afterClosed$.subscribe((event: VexPopoverCloseEvent) => {
      item.opened = false;
    });
  }

  triggerButtonClickByLabel(label: string): void {
    const toolbarButton = this.toolbarItems.toArray().find(item => {
      const nativeElement = item.nativeElement;
      const button = nativeElement.querySelector('button');
      return button && button.textContent.trim() === label;
    });

    if (toolbarButton) {
      const nativeElement = toolbarButton.nativeElement;
      const button = nativeElement.querySelector('button') as HTMLElement;
      if (button) {
        button.click(); // Programmatically trigger the click event on the button
      }
    }
  }
}

